import { render, staticRenderFns } from "./pageViews-edit.vue?vue&type=template&id=cff8096c&"
import script from "./pageViews-edit.vue?vue&type=script&lang=js&"
export * from "./pageViews-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports